const getAssetType = function (type) {
  if (type && type.assetType) {
    return getAssetType(type.assetType)
  }
  if (typeof(type) === 'string') {
    if (/(\.pdf)|MaterialDataSheet|ProductDataSheet|application\/pdf/i.test(type)) {
      return 'pdf-mime-type'
    }
    else if (type.includes('image/')) {
      return 'image'
    }
    else if (type === 'CAD') {
      return 'cad'
    }
  }
  return 'file'
}

export default getAssetType
